<template>
  <el-menu class="toggle" style="border-right: 0">
    <div class="toggle">
      <div class="title">标签打印追溯系统管理后台</div>
    </div>
    <el-menu
      :default-openeds="subMenuActiveName"
      :unique-opened="true"
      class="el-menu-style"
      @select="clickMenuItem">
      <!-- <el-submenu v-for="(item, index) in menu" :key="index" :index="item.name">
        <template slot="title">
          <span>{{item.name}}</span>
        </template>
        <el-menu-item-group>
          <router-link v-for="(submenu, i) in item.childrenList" :key="i" :to="submenu.url">
            <el-menu-item :key="i" :index="submenu.name">{{submenu.name}}</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu> -->
      <template v-for="(item,index) in menu">
        <el-submenu :index="item.name" :key="index">
          <template slot="title">
            <i style="color:#d6eb93;" :class="`el-icon-${item.icon}`"></i>
            <span>{{item.name}}</span>
          </template>
          <template v-for="(v,i) in item.childrenList">
            <router-link :key="i" :to="v.url">
              <el-menu-item :key="i" :index="v.name">{{v.name}}</el-menu-item>
            </router-link>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </el-menu>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'main-menu',
    data() {
      return {
        menu: JSON.parse(sessionStorage.getItem('moduleList') || '[]')
      }
    },
    computed: {
      ...mapGetters([
        'subMenuActiveName'
      ])
    },
    created() {
      this.setUserInfo(JSON.parse(sessionStorage.getItem('userInfo') || '[]'))
      this.setRoles(JSON.parse(sessionStorage.getItem('moduleList') || '[]'))
    },
    methods: {
      clickMenuItem(index) {
        this.setCurrentRoles(index)
        let menuList = this.formartMenuList()
        let obj = menuList.find(item => {
          return item.name === index
        })
        this.setTabs(obj)
      },
      formartMenuList() {
        let list = []
        let menuList = this.menu
        for (var i in menuList) {
          let subMenuList = menuList[i].childrenList
          for (var j in subMenuList) {
            let obj = {
              name: subMenuList[j].name,
              url: subMenuList[j].url,
              closable: true
            }
            list.push(obj)
          }
        }
        return list
      },
      ...mapMutations({
        setTabs: 'SET_TABS',
        setUserInfo: 'SET_USERINFO',
        setRoles: 'SET_ROLES',
        setCurrentRoles: 'SET_CURRENT_ROLES'
      })
    }
  }
</script>

<style lang="stylus">
  .el-menu
    border-right none
    background-color #262A35
    width 260px
    .toggle
      text-align center
      .title
        color #fff
        line-height 60px
        height 60px
        font-size 16px
    .el-menu-style
      user-select none
      .el-submenu__title
        color #fff
        &:hover, &:focus
          background-color #1D1F2B
      .el-menu-item
        color #fff
        &:hover, &:focus
          background-color #2F3543
      .is-opened
        .el-submenu__title
          background-color #1D1F2B
</style>
